import Avatar from "@mui/material/Avatar";
import { Box, Typography } from "@mui/material";
import color from "context/MaterialUITheme/color";

interface Prop {
  nmls: number;
  company?: string;
  lastName: string;
  firstName: string;
  borrowerName?: string;
  companyNMLS?: string;
  profilePicture?: string;
  avatar?: string;
}

export default function LoanOfficerInformation({
  nmls,
  company,
  lastName,
  firstName,
  borrowerName,
  profilePicture,
  companyNMLS,
  avatar,
}: Prop) {
  return (
    <Box
      display={"flex"}
      borderRadius={10}
      bgcolor={color.white}
      mb={3}
      py={5}
      px={7}
      position="relative"
      justifyContent={"space-between"}
      alignItems={{ xs: "center", sm: "flex-start" }}
      flexDirection={{ xs: "column", sm: "row" }}
    >
      <Box
        width={{ sm: "30%", xs: undefined }}
        mr={2}
        position="relative"
        flexDirection={"column"}
        display={"flex"}
      >
        <Box
          width={105}
          height={105}
          display={"flex"}
          borderRadius={90}
          alignSelf={"center"}
          bgcolor={color.purple}
          justifyContent={"center"}
        >
          <Avatar
            src={avatar ?? profilePicture}
            alt="Img avatar"
            sx={{
              padding: 0,
              width: 100,
              height: 100,
              alignSelf: "center !important",
            }}
          />
        </Box>
        <Typography
          mt={1}
          variant="h6"
          color={color.purple}
          alignSelf={"center"}
          textAlign="center"
          fontFamily={"Pro Display Semibold"}
        >
          {firstName} {lastName}
        </Typography>
        <Typography
          lineHeight={1}
          variant="subtitle1"
          color={color.black}
          alignSelf={"center"}
          textAlign="center"
          fontFamily={"Pro Display Semibold"}
        >
          NMLS ID# {nmls}
        </Typography>
      </Box>
      <Box py={{ xs: 0, sm: 2 }} mt={{ xs: 3, sm: 0 }} flex={1}>
        <Typography variant="h6" color={color.black} textAlign={"left"}>
          <span style={{ fontFamily: "Pro Display Semibold" }}>
            Hi{borrowerName ? " " + borrowerName : ""}, hope you are well.{" "}
          </span>
          Interested in accessing your equity? We now offer Home Equity Loans
          through NFTYDoor LLC. You can fill out the below and see your offer
          instantly without any obligation or credit check.
        </Typography>
        <Typography
          variant="subtitle1"
          color={color.purple}
          alignSelf={"center"}
          textAlign="left"
          fontFamily={"Pro Display Semibold"}
        >
          {company}
          <br />
          NMLS ID # {companyNMLS}
        </Typography>
      </Box>
    </Box>
  );
}
